import { render, staticRenderFns } from "./AdvertBanner.vue?vue&type=template&id=44f68333&scoped=true&"
import script from "./AdvertBanner.vue?vue&type=script&lang=js&"
export * from "./AdvertBanner.vue?vue&type=script&lang=js&"
import style0 from "./AdvertBanner.vue?vue&type=style&index=0&id=44f68333&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f68333",
  null
  
)

export default component.exports